// const waveLength = 13

// const defaultWave = [0.2, 0.6, 1, 0.6, 0.2, 0.6, 1, 2, 1.4, 1.4, 0.6, 0.6, 0.2]

// const getRandomWave = () => {
//   const arr = []
//   for (let i = 0; i < waveLength; i++) {
//     arr.push(Math.random() * 3)
//   }
//   return arr
// }

export default container => {
  const soundButton = container.querySelector('[data-sound]')
  const videos = container.querySelectorAll('[data-video]')
  const soundIcon = container.querySelector('[data-sound-icon]')
  // const waveLines = []
  // let int

  if (!soundButton) return

  // create wave lines
  // for (let i = 0; i < waveLength; i++) {
  //   const line = document.createElement('span')
  //   line.classList.add('hero__sound-vertical-line')
  //   line.dataset.soundLine = 'wave'
  //   soundButton.append(line)
  //   waveLines.push(line)
  // }

  // const applyArray = array =>
  //   waveLines.forEach((wave, index) => {
  //     wave.style.transform = `scaleY(${array[index]})`
  //   })

  // applyArray(defaultWave)

  soundButton.addEventListener('click', () => {
    videos.forEach(video => {
      video.muted = !video.muted

      if (video.muted) {
        soundIcon.classList.add('mute')
        // clearInterval(int)
        // applyArray(defaultWave)
      } else {
        soundIcon.classList.remove('mute')
        //   int = setInterval(() => {
        //     applyArray(getRandomWave())
        //   }, 200)
      }
    })
  })
}
